import { appBaseUrl } from "utils/config";
import queryString from "query-string";
import { getService, postService, putService } from "services/commonServices";
import { isEmpty } from "lodash";

export class RotoService {
  getRotoListing() {
    let url = `${appBaseUrl}/referenceManagement/onlyRoto`;

    try {
      const data = getService(url);
      return data;
    } catch (error) {
      console.error("Error fetching roto listing:", error);
      throw error;
    }
  }

  getRotoPaginationListNew(body) {
    let url = `${appBaseUrl}/referenceManagement/rotoPaginationList_New`;
    let data = postService(url, body);
    return data;
  }

  createRoto(body) {
    let url = `${appBaseUrl}/referenceManagement/onlyRotoAdd`;
    let data = postService(url, body);
    return data;
  }

  updateRoto(body) {
    let url = `${appBaseUrl}/referenceManagement/onlyRotoUpdate`;
    let data = postService(url, body);
    return data;
  }

  // getRotoCategoryDetails(id) {
  //   let url = `${appBaseUrl}/adminModule/tutorialTypeGetDetails/${id}`;
  //   let data = getService(url);
  //   return data;
  // }
}
